import clsx from 'clsx'
import PropTypes from 'prop-types'
import { Image } from 'components'
import Markdown from 'react-markdown'
import { motion } from 'framer-motion'

// Motion Variants
import * as motionVariants from './motion.variants'

// Styles
import styles from './style.module.scss'

export const CoreValueItem = ({ data }) => {
  let image_one = data.image_one ? data.image_one.url : ""
  let image_two = data.image_two ? data.image_two.url : ""

  return (
    <motion.div variants={motionVariants.container} initial="hidden" animate="visible" exit="exit">
      <div className={styles.tab_inner}>
        <motion.div variants={motionVariants.child} className={styles.tab_thumbnail_wrapper}>
          <div className={styles.tab_thumbnail_inner}>
            <Image
              src={image_one}
              alt={`${data.title}`}
              layout='fill'
              objectFit='contain'
            />
          </div>
        </motion.div>

        <motion.div variants={motionVariants.child} className={styles.tab_content}>
          <h1 className={clsx('section-subtitle', styles.tab_title)}>{data.title}</h1>

          <div className="section-copy">
            <Markdown className={styles.tab_copy} source={data.description} />
          </div>
        </motion.div>

        <motion.div variants={motionVariants.child} className={styles.tab_image_wrapper}>
          <div className={styles.tab_image_inner}>
            <Image
              className={styles.tab_image}
              src={image_two}
              objectFit="contain"
              objectPosition="center"
              width={240}
              height={240}
              alt=""
            />
          </div>
        </motion.div>
      </div>
    </motion.div>
  )
}

CoreValueItem.propTypes = {
  data: PropTypes.object.isRequired,
}

export default CoreValueItem
